module.exports = __webpack_public_path__ + "../static/img/fortinet-logo.f6da49df.jpg";